export default class MenuFamilyNeedALoanFormatter {
  constructor(rawData) {
    this._rawData = rawData;
  }

  format() {
    const cardsData = this._getCardsData();
    const moreInfoData = this._getMoreInfoData();
    const tableData = this._getTableData();
    const creditworthinessOfLoans = this._getCreditworthinessOfLoans();
    return {
      cardsData,
      moreInfoData,
      tableData,
      creditworthinessOfLoans
    };
  }

  _getCardsData() {
    return [
      {
        title:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.TITLE',
        subtitle:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.SUBTITLE',
        description:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.MAX_MONTH_FEE.DESC',
        amount: this._rawData.maximumMonthFee,
      },
      {
        title:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.TITLE',
        subtitle:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.SUBTITLE',
        description:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_OBLIGATIONS.DESC',
        amount: this._rawData.yourObligations,
      },
      {
        title:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.TITLE',
        subtitle:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.SUBTITLE',
        description:
          'LOANS.CREDITWORTHINESS.MONTHLY_AMORTIZATION.CARDS.YOUR_REAL_CAPACITY.DESC',
        amount: this._rawData.yourRealCapacity,
      },
    ];
  }

  _getMoreInfoData() {
    return [
      {
        title:
          'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.SUBTITLE',
        information: [
          'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.DESCRIPTION1',
          'LOANS.CREDITWORTHINESS.MORE_INFO.ABOUT_CREDITWORTHINESS.DESCRIPTION2',
        ],
      },
      {
        title:
          'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.SUBTITLE',
        information: [
          'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.DESCRIPTION1',
          'LOANS.CREDITWORTHINESS.MORE_INFO.FACTORS_CREDITWORTHINESS.DESCRIPTION2',
        ],
      },
      {
        title: 'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.SUBTITLE',
        information: [
          'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION1',
          'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION2',
          'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION3',
          'LOANS.CREDITWORTHINESS.MORE_INFO.LOANS_COMPATIBILITY.DESCRIPTION4',
        ],
      },
    ];
  }

  _getTableData() {
    const headers = this._getTableHeaders();
    const labels = [
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_VARIABLE',
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_FIXED',
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_VARIABLE',
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_FIXED'
    ];

    const rows = this._rawData.simulatedLimits.map((value, idx) => {
      return [
        { text: labels[idx], translate: true },
        { text: value,       currency: true }
      ];
    });

    return { headers, rows };
  }

  _getTableHeaders() {
    return [
      {
        text: 'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.TYPE',
        width: 329,
        translate: true,
      },
      {
        text:
          'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SIMULATION_MAX_LIMIT_WITH_INSURANCE',
        width: 329,
        translate: true,
      },
    ];
  }

  _getCreditworthinessOfLoans() {
    const loanNames = [
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_VARIABLE',
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_LOAN_FIXED',
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_VARIABLE',
      'LOANS.CREDITWORTHINESS.BY_LOAN_TYPE.TABLE.SOCIAL_HOUSING_AGREEMENT_FIXED'
    ];

    const rows = this._rawData.simulatedLimits.map((value, idx) => {
      return {
        loanName: loanNames[idx],
        realWithInsuranceLimit: value
      };
    });

    return rows;
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuFamilyNeedALoan.formatter.js